import { render, staticRenderFns } from "./baleIndex.vue?vue&type=template&id=c032af00&scoped=true&"
import script from "./baleIndex.vue?vue&type=script&lang=js&"
export * from "./baleIndex.vue?vue&type=script&lang=js&"
import style0 from "./baleIndex.vue?vue&type=style&index=0&id=c032af00&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c032af00",
  null
  
)

export default component.exports